function removeItem(productKey, accessoryKey) {
  var data = {
    updates: {
      [`${productKey}`]: 0,
      [`${accessoryKey}`]: 0,
    },
  };

  fetch("/cart/update.js", {
    method: "POST",
    body: JSON.stringify(data),
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "xmlhttprequest",
    },
  })
    .then((response) => response.json())
    .then(function () {
      location.reload();
    });
}

function removeAccessory() {
  const removeAccButton = document.querySelectorAll(".js-accessory-remove");

  removeAccButton.forEach((el) => {
    el.addEventListener("click", function (evt) {
      evt.preventDefault();
      const cartId = el.closest(".cart__item").getAttribute("data-cart-id");
      const accessoryKey = document.querySelector(`.accessory[data-cart-id="${cartId}"]`).getAttribute("data-key");

      if (accessoryKey) {
        evt.preventDefault();
        const productKey = el.closest(".cart__item").getAttribute("data-key");

        removeItem(productKey, accessoryKey);
      }
    });
  });
}

removeAccessory();
